import { BottomFloatingButton } from '../../../../components/common/buttons/FloatingButtons/BottomFloatingButton';
import { Icon } from '../../../../components/common/icon/Icon';
import { postMessageToRN } from '../../../../utils/RNCommunicator/postMessageToRN.util';

export const SellTractorInquiryButton = () => {
  const handleButtonClick = () => {
    if (window.ReactNativeWebView) {
      postMessageToRN({ messageKey: 'link', messageParam: 'tel:0316074997' });
    } else {
      window.location.href = 'tel:0316074997';
    }
  };

  return (
    <BottomFloatingButton
      handleButtonClick={handleButtonClick}
      icon={<Icon name={'Phone'} size={'Large'} fill={'#FFFFFF'} />}
      title={'문의하기'}
    />
  );
};
